module.exports = __webpack_public_path__ + "static/media/uww_logo.53f8877e.svg";